import { createContext } from "react";

const ToggleContext = createContext({});

export default ToggleContext;
